var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _circle, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 46,
    fill: "#F2F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2766 29.0858C14.2766 29.0858 10.5161 29.0985 10.5161 32.8462C10.5161 29.0985 6.75566 29.0858 6.75566 29.0858C6.75566 29.0858 10.5161 29.0729 10.5161 25.3253C10.5161 29.0729 14.2766 29.0858 14.2766 29.0858Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7959 59.313C87.7959 59.313 84.0354 59.3258 84.0354 63.0735C84.0354 59.3258 80.275 59.313 80.275 59.313C80.275 59.313 84.0354 59.3002 84.0354 55.5526C84.0354 59.3002 87.7959 59.313 87.7959 59.313Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8261,
    y: 17.8085,
    width: 41.0111,
    height: 52.083,
    rx: 1.88141,
    transform: "rotate(15.9553 35.8261 17.8085)",
    fill: "#E1E4EA",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8094 26.5319L59.9859 67.8873C58.9495 71.5121 55.1736 73.6089 51.5488 72.5726L23.1837 64.463C20.6941 63.7512 19.255 61.1597 19.9667 58.6702L32.3782 15.2585C32.6663 14.2508 33.7158 13.668 34.7234 13.9561L70.507 24.1866C71.5147 24.4747 72.0975 25.5242 71.8094 26.5319Z",
    fill: "white",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5487 72.5727L20.4882 63.6778C18.3452 63.0651 17.1034 60.8358 17.716 58.6928C18.2597 56.7914 20.0903 55.5984 21.993 55.7921L22.1226 55.8046L53.9417 59.1999C50.7714 58.9545 47.7674 60.9563 46.8588 64.1344C45.8224 67.7592 47.9193 71.5351 51.5487 72.5727Z",
    fill: "#CACFD8",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2199,
    y: 47.9346,
    width: 2.27014,
    height: 6.25447,
    rx: 0.940704,
    transform: "rotate(15.9553 46.2199 47.9346)",
    fill: "#E1E4EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5411,
    y: 48.4835,
    width: 2.27014,
    height: 7.73891,
    rx: 0.940704,
    transform: "rotate(15.9553 53.5411 48.4835)",
    fill: "#E1E4EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5872,
    y: 45.7377,
    width: 2.27014,
    height: 9.56697,
    rx: 0.940704,
    transform: "rotate(15.9553 50.5872 45.7377)",
    fill: "#E1E4EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.547,
    y: 52.4773,
    width: 2.27014,
    height: 4.72552,
    rx: 0.940704,
    transform: "rotate(15.9553 56.547 52.4773)",
    fill: "#E1E4EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5293,
    cy: 46.7792,
    r: 6.4214,
    transform: "rotate(15.9553 35.5293 46.7792)",
    fill: "white",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2113 50.378C30.9221 48.5469 32.8323 47.4682 34.7621 47.7974C33.8238 47.3087 33.3261 46.2127 33.6283 45.1559C33.9735 43.9483 35.2324 43.2492 36.44 43.5944C37.6476 43.9397 38.3467 45.1985 38.0014 46.4061C37.6993 47.463 36.6975 48.1303 35.6426 48.0491C37.4548 48.7898 38.5062 50.715 38.1418 52.6451C36.8118 53.2381 35.2739 53.3845 33.7642 52.9529C32.2548 52.5214 31.0267 51.5843 30.2113 50.378Z",
    fill: "#99A0AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7621 47.7974L34.7099 48.1038C34.8608 48.1295 35.0079 48.0416 35.0567 47.8965C35.1055 47.7514 35.0415 47.5924 34.9057 47.5217L34.7621 47.7974ZM30.2113 50.378L29.9215 50.2656C29.8846 50.3606 29.8967 50.4677 29.9538 50.5521L30.2113 50.378ZM35.6426 48.0491L35.6665 47.7392C35.5139 47.7275 35.3754 47.8286 35.3402 47.9775C35.3049 48.1265 35.3834 48.2789 35.5251 48.3368L35.6426 48.0491ZM38.1418 52.6451L38.2684 52.9289C38.3614 52.8874 38.4283 52.8029 38.4472 52.7027L38.1418 52.6451ZM34.8144 47.491C32.7392 47.1371 30.6858 48.2965 29.9215 50.2656L30.501 50.4905C31.1583 48.7973 32.9254 47.7994 34.7099 48.1038L34.8144 47.491ZM33.3294 45.0704C32.9859 46.272 33.5519 47.5176 34.6186 48.0731L34.9057 47.5217C34.0957 47.0999 33.6664 46.1533 33.9271 45.2413L33.3294 45.0704ZM36.5254 43.2956C35.1528 42.9032 33.7219 43.6978 33.3294 45.0704L33.9271 45.2413C34.2252 44.1987 35.312 43.5952 36.3546 43.8933L36.5254 43.2956ZM38.3003 46.4916C38.6927 45.1189 37.8981 43.688 36.5254 43.2956L36.3546 43.8933C37.3971 44.1913 38.0007 45.2781 37.7026 46.3207L38.3003 46.4916ZM35.6188 48.359C36.8179 48.4513 37.9567 47.6932 38.3003 46.4916L37.7026 46.3207C37.4418 47.2327 36.577 47.8093 35.6665 47.7392L35.6188 48.359ZM38.4472 52.7027C38.839 50.6273 37.7088 48.5578 35.7602 47.7614L35.5251 48.3368C37.2007 49.0217 38.1733 50.8027 37.8363 52.5874L38.4472 52.7027ZM38.0152 52.3612C36.7495 52.9256 35.2865 53.0649 33.8497 52.6541L33.6788 53.2518C35.2612 53.7042 36.8742 53.5506 38.2684 52.9289L38.0152 52.3612ZM33.8497 52.6541C32.413 52.2433 31.2448 51.352 30.4688 50.204L29.9538 50.5521C30.8086 51.8166 32.0965 52.7994 33.6788 53.2518L33.8497 52.6541Z",
    fill: "#99A0AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6728 32.4407L65.6678 29.0543L62.1758 30.8692L64.5716 22.4896L70.0685 24.0611L67.6728 32.4407Z",
    fill: "#CACFD8",
    stroke: "#99A0AE",
    strokeWidth: 0.621622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmpty);
export default __webpack_public_path__ + "static/media/ic_empty.5d7272fa59a960799516a9bb7ace7274.svg";
export { ForwardRef as ReactComponent };